import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../helpers/MetaTag";
import Button from "../components/form/Button";
import Textarea from "../components/form/Textarea";
import NoDataFound from "../components/NoDataFound";
import toastr from "toastr";
import Accordian from "../components/Common/Accordian";
import Search from "../components/form/Search";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import PositionCompetenciesSkelton from "../components/loader/PositionCompetenciesSkelton";
import { Tooltip } from "react-tooltip";
import AddEditPositionPopup from "../components/popup/AddEditPositionPopup";
import DeletePopup from "../components/DeletePopup";

const Competencies = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Succession Plan Position Competencies"
  );
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [competenciesData, setCompetenciesData] = useState([]);
  const [competenciesResetData, setCompetenciesResetData] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [allData, setAllData] = useState([]);
  const [actionValue, setActionValue] = useState({});
  const [enabledDeletePopup, setenabledDeletePopup] = useState({
    isOpen: false,
    data: null,
  });
  const [isOpen, setIsopen] = useState({
    _id: null,
    open: false,
  });

  // useEffect(() => {
  //   async function positionListFun() {
  //     setLoading(true);
  //     try {
  //       const result = await postData("position/list", {
  //         sortQuery: { ordering: 1 },
  //         status: 1,
  //       });
  //       if (result.data) {
  //         setCompetenciesData(
  //           result.data.map((value, key) => {
  //             return {
  //               ...value,
  //               position_competencies: value?.position_competencies
  //                 ? value?.position_competencies
  //                 : "",
  //               different_competencies: value?.different_competencies
  //                 ? value?.different_competencies
  //                 : "",
  //             };
  //           })
  //         );
  //         setCompetenciesResetData(result.data);
  //         setLoading(false);
  //       } else {
  //         console.log("Position message", result.message);
  //         setLoading(false);
  //       }
  //     } catch (error) {
  //       console.log("Error role catch", error.message);
  //       setLoading(false);
  //     }
  //   }
  //   positionListFun();
  // }, [isUpdate || ""]);

  const loadList = useCallback(async () => {
    setLoading(true);
    try {
      const result = await postData("position/list", {
        sortQuery: { created_at: 1 },
        status: 1,
      });
      if (result.data) {
        setCompetenciesData(
          result.data.map((value, key) => {
            return {
              ...value,
              position_competencies: value?.position_competencies
                ? value?.position_competencies
                : "",
              different_competencies: value?.different_competencies
                ? value?.different_competencies
                : "",
            };
          })
        );
        setCompetenciesResetData(result.data);
        setLoading(false);
      } else {
        console.log("Position message", result.message);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error role catch", error.message);
      setLoading(false);
    }
  }, [isUpdate || ""]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  const handelUpdate = async (id, index, value, field) => {
    let temp = [...competenciesData];
    if (field === "position_competencies") {
      temp[index].position_competencies = value;
      setCompetenciesData(temp);
    }
    if (field === "different_competencies") {
      temp[index].different_competencies = value;
      setCompetenciesData(temp);
    }
  };

  const onCancel = async (e) => {
    setIsCancel(true);
    setCompetenciesData(
      competenciesResetData.map((value, key) => {
        return {
          ...value,
          position_competencies: value?.position_competencies
            ? value?.position_competencies
            : "",
          different_competencies: value?.different_competencies
            ? value?.different_competencies
            : "",
        };
      })
    );
    setIsCancel(false);
  };

  const onUpdate = async (e) => {
    setIsUpdate(false);
    setIsSave(true);
    try {
      const result = await postData("position/competency-update", {
        competencies_data: competenciesData,
      });
      if (result.data && result.status === 200) {
        toastr.success(result.message);
        setIsUpdate(true);
        setIsSave(false);
      } else {
        toastr.error(result.message);
        setIsUpdate(false);
        setIsSave(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsUpdate(false);
      setIsSave(false);
    }
  };

  const toggleAccordion = (id) => {
    setOpenAccordionId(openAccordionId === id ? null : id);
  };

  useEffect(() => {
    if (keyword) {
      const filteredArray = competenciesData.filter((item) =>
        item?.name.toLowerCase().includes(keyword.toLowerCase())
      );
      setAllData(filteredArray.sort((a, b) => a.name.localeCompare(b.name)));
    } else {
      setAllData(competenciesData.sort((a, b) => a.name.localeCompare(b.name)));
    }
  }, [competenciesData, keyword]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        setIsUpdate(true);
        try {
          const deleteData = await postData("position/delete", {
            id: actionValue?.row_id,
          });
          if (deleteData.data) {
            setenabledDeletePopup({
              isOpen: false,
              data: {},
            });
            setActionValue({});
          } else {
            toastr.error(deleteData.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
        setIsUpdate(false);
      };
      loadDeleteRecord();
    }
  }, [actionValue]);

  return (
    <>
      <div className="border bg-white border-gray-200 p-4 shadow-md rounded-xl">
        <div className="relative flex gap-3 items-center mb-3 flex-wrap sm:flex-nowrap gap-y-4">
          <div className="text-2xl font-bold">
            {t("succession_plan_position_competencies")}
          </div>
        </div>

        <div className="relative flex gap-3 items-center mb-3 flex-wrap">
          <div className="relative w-48">
            <Search placeholder={"Search"} setInput={setKeyword} />
          </div>
          <div
            className="sm:ml-auto flex justify-end items-center"
            data-tooltip-id={`buttonPosition${1}`}
            data-tooltip-place="right"
          >
            <Button
              buttonType={"button"}
              buttonIcon={"fa-light fa-plus"}
              buttonIconPosition={"left"}
              buttonLabel={t("add")}
              buttonHasLink={false}
              functions={() => setIsopen({ _id: null, open: true })}
            />

            <Tooltip
              id={`buttonPosition${1}`}
              className="!text-xs !bg-teal-500 z-50 rounded py-2 px-2 !opacity-100"
              render={() => (
                <div className="gap-x-1 gap-y-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">Add New Position</div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
        <div className="relative  rounded">
          <form className="relative space-y-2">
            {allData?.length > 0 ? (
              allData?.map((item, index) => (
                <div className="flex items-start justify-center rounded-lg gap-3">
                  <div className="gap-3 flex-grow flex-shrink">
                    <Accordian
                      key={index}
                      id={index}
                      title={
                        <div className="flex items-center gap-5">
                          <span>{item.name}</span>
                          {
                            item?.is_default && <span className="inline-flex items-center justify-center py-1 px-1.5 bg-teal-500 rounded text-[10px] text-white font-medium !leading-none">Predefined</span>
                          }                          
                        </div>
                      }
                      isOpen={openAccordionId === index}
                      toggleAccordion={toggleAccordion}
                      divClass={"border border-slate-200 rounded-md"}
                      childClass={"!px-3 !pb-3 !pt-0"}
                    >
                      <div className="text-sm md:text-base font-Inter text-slate-700">
                        <div className="relative space-y-4">
                          <div className="relative">
                            <Textarea
                              inputClasses={
                                "whitespace-pre-line !h-40 sm:!h-80"
                              }
                              label={t(
                                "document_position_competencies_in_section_below"
                              )}
                              isAddBullet={true}
                              inputValue={item?.position_competencies}
                              setTextarea={(val) =>
                                handelUpdate(
                                  item._id,
                                  index,
                                  val,
                                  "position_competencies"
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Accordian>
                  </div>
                  <div className="flex-shrink-0 flex items-start justify-start gap-2 pt-2">
                    <div
                      className="cursor-pointer p-1 rounded  transition"
                      onClick={() => setIsopen({ open: true, _id: item?._id })}
                    >
                      <i className="fa-regular fa-pen text-teal-500 hover:text-teal-700 text-base"></i>
                    </div>

                    <div
                      className="cursor-pointer p-1 rounded transition"
                      onClick={() => {
                        setenabledDeletePopup({
                          isOpen: true,
                          data: item?._id,
                        });
                      }}
                    >
                      <i className="fa-regular fa-trash text-rose-600 hover:text-rose-700 text-base"></i>
                    </div>
                  </div>
                </div>
              ))
            ) : loading ? (
              <PositionCompetenciesSkelton />
            ) : (
              <NoDataFound label={t("no_data_found")} />
            )}
          </form>

          {competenciesData?.length > 0 && (
            <div className="py-3 px-3 border-t border-slate-200">
              <div className="flex items-center justify-end gap-4">
                <Button
                  buttonType={"button"}
                  buttonIcon={
                    isCancel
                      ? "fa-light fa-spinner fa-spin"
                      : "fa-light fa-times"
                  }
                  buttonIconPosition={"left"}
                  buttonLabel={t("cancel")}
                  buttonClasses={
                    "!bg-slate-200 !text-slate-600 border border-slate-300"
                  }
                  functions={onCancel}
                  buttonHasLink={false}
                  buttonDisabled={isCancel}
                />
                <Button
                  buttonType={"button"}
                  buttonIcon={
                    isSave ? "fa-light fa-spinner fa-spin" : "fa-light fa-check"
                  }
                  buttonIconPosition={"left"}
                  buttonLabel={t("save")}
                  functions={onUpdate}
                  buttonHasLink={false}
                  buttonDisabled={isSave}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {isOpen?.open && (
        <AddEditPositionPopup
          isOpen={isOpen?.open}
          id={isOpen?._id}
          setIsOpen={setIsopen}
          loadList={loadList}
        />
      )}
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup?.isOpen}
          setIsOpen={(val) => setenabledDeletePopup({ isOpen: val })}
          currentId={enabledDeletePopup?.data}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
          
        />
      )}
    </>
  );
};

export default Competencies;
